import {onFind} from "@elements/init-modules-in-scope";
import BlazeSlider from 'blaze-slider';
import {addClass, find} from "@elements/dom-utils";

export function init() {
    onFind('.js-event-img-teaser-slider', function (baseElement) {

        //Workaround to set slidesToShow to given values as blaze-slider overwrites slidesToShow if number of items is less than slidesToShow
        const slidesToShow = 2.1;
        const slidesToShow767 = 1;
        const slidesToShow1200 = 2;
        const maxWidth = '(max-width: 767px)';
        let style = document.createElement('style');
        style.id = 'event-img-teaser-slider';
        style.innerHTML = '.slidesToShow--eventImgTeaser { --slides-to-show: ' + (window.matchMedia(maxWidth).matches ? slidesToShow767 : slidesToShow) + ' !important; }';
        let head = find('head');
        if (!find('#' + style.id, head)) {
            head.appendChild(style);
        }

        new BlazeSlider(baseElement, {
            all: {
                loop: false,
                slidesToScroll: slidesToShow,
                slideGap: '8px',
                slidesToShow: 2.1,
                draggable: true,

            },

            '(max-width: 1200px)': {
                slidesToShow: slidesToShow1200
            },

            '(max-width: 767px)': {
                slidesToShow: slidesToShow767
            },
        });

        addClass('slidesToShow--eventImgTeaser', baseElement);
    });
}